<template>
  <div class="quality-thank-you">
    <div class="quality-thank-you__img-wrap">
      <img
        class="quality-thank-you__img"
        :src="`/img/svgo/thank-you-empty.svg`"
        :alt="'Дякуємо'"
      />
      <p class="quality-thank-you__img-text">{{ computedMessage }}</p>
    </div>
    <h3 class="quality-thank-you__title">
      {{ $t('quality_thank_you_title1') }}
      <br>
      {{ $t('quality_thank_you_title2') }}
    </h3>
    <a class="quality-thank-you__link" href="/">
      {{ $t('quality_thank_you_link') }}
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ThankYou',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    computedMessage () {
      return this.$t('quality_thank_you_message', { name: this.userName ? `${this.userName}, ` : '' })
    }
  }
}
</script>

<style lang="sass" scoped>

.quality-thank-you
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  max-width: 600px
  margin: 0 auto

.quality-thank-you__img-wrap
  position: relative

.quality-thank-you__img
  margin: 0 0 40px
  max-width: 370px

  +mmin(390)
    max-width: 460px

.quality-thank-you__img-text
  position: absolute
  top: 41%
  left: 40%
  font-size: 16px
  font-weight: 500
  max-width: 160px

  +mmin(390)
    top: 43%
    font-size: 18px
    max-width: 200px

.quality-thank-you__title
  display: block
  padding: 0
  text-align: center
  font-style: normal
  font-weight: 500
  font-size: 24px
  line-height: 150%
  color: $text-color
  margin: 0 0 20px

.quality-thank-you__text
  margin: 0 0 100px
  padding: 0
  font-style: normal
  font-weight: 400
  font-size: 16px
  line-height: 150%

.quality-thank-you__link
  color: $nd-link-color

  &:hover
    text-decoration-line: underline
</style>
